/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

export interface UserCurrentStatus {
  offline?: UserCurrentStatus_Offline | undefined;
  online?: UserCurrentStatus_Online | undefined;
  streaming?: UserCurrentStatus_Live | undefined;
  viewing?: UserCurrentStatus_Live | undefined;
}

export interface UserCurrentStatus_Offline {
  /** nullの場合、`N分前` 的な表示もなくなる */
  lastConnectTime?: string | undefined;
}

export interface UserCurrentStatus_Online {
}

export interface UserCurrentStatus_Live {
  mediaId: number;
}

function createBaseUserCurrentStatus(): UserCurrentStatus {
  return { offline: undefined, online: undefined, streaming: undefined, viewing: undefined };
}

export const UserCurrentStatus = {
  encode(message: UserCurrentStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.offline !== undefined) {
      UserCurrentStatus_Offline.encode(message.offline, writer.uint32(10).fork()).ldelim();
    }
    if (message.online !== undefined) {
      UserCurrentStatus_Online.encode(message.online, writer.uint32(18).fork()).ldelim();
    }
    if (message.streaming !== undefined) {
      UserCurrentStatus_Live.encode(message.streaming, writer.uint32(26).fork()).ldelim();
    }
    if (message.viewing !== undefined) {
      UserCurrentStatus_Live.encode(message.viewing, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserCurrentStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserCurrentStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.offline = UserCurrentStatus_Offline.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.online = UserCurrentStatus_Online.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.streaming = UserCurrentStatus_Live.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.viewing = UserCurrentStatus_Live.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserCurrentStatus {
    return {
      offline: isSet(object.offline) ? UserCurrentStatus_Offline.fromJSON(object.offline) : undefined,
      online: isSet(object.online) ? UserCurrentStatus_Online.fromJSON(object.online) : undefined,
      streaming: isSet(object.streaming) ? UserCurrentStatus_Live.fromJSON(object.streaming) : undefined,
      viewing: isSet(object.viewing) ? UserCurrentStatus_Live.fromJSON(object.viewing) : undefined,
    };
  },

  toJSON(message: UserCurrentStatus): unknown {
    const obj: any = {};
    if (message.offline !== undefined) {
      obj.offline = UserCurrentStatus_Offline.toJSON(message.offline);
    }
    if (message.online !== undefined) {
      obj.online = UserCurrentStatus_Online.toJSON(message.online);
    }
    if (message.streaming !== undefined) {
      obj.streaming = UserCurrentStatus_Live.toJSON(message.streaming);
    }
    if (message.viewing !== undefined) {
      obj.viewing = UserCurrentStatus_Live.toJSON(message.viewing);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserCurrentStatus>, I>>(base?: I): UserCurrentStatus {
    return UserCurrentStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserCurrentStatus>, I>>(object: I): UserCurrentStatus {
    const message = createBaseUserCurrentStatus();
    message.offline = (object.offline !== undefined && object.offline !== null)
      ? UserCurrentStatus_Offline.fromPartial(object.offline)
      : undefined;
    message.online = (object.online !== undefined && object.online !== null)
      ? UserCurrentStatus_Online.fromPartial(object.online)
      : undefined;
    message.streaming = (object.streaming !== undefined && object.streaming !== null)
      ? UserCurrentStatus_Live.fromPartial(object.streaming)
      : undefined;
    message.viewing = (object.viewing !== undefined && object.viewing !== null)
      ? UserCurrentStatus_Live.fromPartial(object.viewing)
      : undefined;
    return message;
  },
};

function createBaseUserCurrentStatus_Offline(): UserCurrentStatus_Offline {
  return { lastConnectTime: undefined };
}

export const UserCurrentStatus_Offline = {
  encode(message: UserCurrentStatus_Offline, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lastConnectTime !== undefined) {
      writer.uint32(10).string(message.lastConnectTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserCurrentStatus_Offline {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserCurrentStatus_Offline();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.lastConnectTime = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserCurrentStatus_Offline {
    return { lastConnectTime: isSet(object.lastConnectTime) ? globalThis.String(object.lastConnectTime) : undefined };
  },

  toJSON(message: UserCurrentStatus_Offline): unknown {
    const obj: any = {};
    if (message.lastConnectTime !== undefined) {
      obj.lastConnectTime = message.lastConnectTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserCurrentStatus_Offline>, I>>(base?: I): UserCurrentStatus_Offline {
    return UserCurrentStatus_Offline.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserCurrentStatus_Offline>, I>>(object: I): UserCurrentStatus_Offline {
    const message = createBaseUserCurrentStatus_Offline();
    message.lastConnectTime = object.lastConnectTime ?? undefined;
    return message;
  },
};

function createBaseUserCurrentStatus_Online(): UserCurrentStatus_Online {
  return {};
}

export const UserCurrentStatus_Online = {
  encode(_: UserCurrentStatus_Online, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserCurrentStatus_Online {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserCurrentStatus_Online();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UserCurrentStatus_Online {
    return {};
  },

  toJSON(_: UserCurrentStatus_Online): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UserCurrentStatus_Online>, I>>(base?: I): UserCurrentStatus_Online {
    return UserCurrentStatus_Online.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserCurrentStatus_Online>, I>>(_: I): UserCurrentStatus_Online {
    const message = createBaseUserCurrentStatus_Online();
    return message;
  },
};

function createBaseUserCurrentStatus_Live(): UserCurrentStatus_Live {
  return { mediaId: 0 };
}

export const UserCurrentStatus_Live = {
  encode(message: UserCurrentStatus_Live, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mediaId !== 0) {
      writer.uint32(8).int64(message.mediaId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserCurrentStatus_Live {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserCurrentStatus_Live();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.mediaId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserCurrentStatus_Live {
    return { mediaId: isSet(object.mediaId) ? globalThis.Number(object.mediaId) : 0 };
  },

  toJSON(message: UserCurrentStatus_Live): unknown {
    const obj: any = {};
    if (message.mediaId !== 0) {
      obj.mediaId = Math.round(message.mediaId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserCurrentStatus_Live>, I>>(base?: I): UserCurrentStatus_Live {
    return UserCurrentStatus_Live.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserCurrentStatus_Live>, I>>(object: I): UserCurrentStatus_Live {
    const message = createBaseUserCurrentStatus_Live();
    message.mediaId = object.mediaId ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
